export default __webpack_public_path__ + "media/images/excel_16px-90969d5f2afed140b66db0c54d6925c5.png";